import React from "react";
import Typography from "@/components/shared/Typography";
import { breakpointClasses, cn, splitBreakpointProps } from "@/lib/utils";
import type { CardTitleProps } from "../types";

function CardTitle({ className, children, ...props }: CardTitleProps) {
  const { bp, native } = splitBreakpointProps(props);
  const classes = breakpointClasses(bp);

  return (
    <Typography.H2
      data-slot="card-title"
      className={cn(
        "text-2xl font-semibold leading-none tracking-tight font-montserrat border-b-0",
        className,
        classes,
      )}
      {...native}
    />
  );
}

CardTitle.displayName = "Card.Title";

export default CardTitle;
